import { render, staticRenderFns } from "./ClientManage.vue?vue&type=template&id=ce2aebce&scoped=true&"
import script from "./ClientManage.vue?vue&type=script&lang=js&"
export * from "./ClientManage.vue?vue&type=script&lang=js&"
import style0 from "./ClientManage.vue?vue&type=style&index=0&id=ce2aebce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2aebce",
  null
  
)

export default component.exports